import { render, staticRenderFns } from "./DigitalSignageBundle.vue?vue&type=template&id=5fca4af2&scoped=true"
import script from "./DigitalSignageBundle.ts?vue&type=script&lang=ts&external"
export * from "./DigitalSignageBundle.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fca4af2",
  null
  
)

export default component.exports